import config from 'config';
import { handleErrors } from 'api/util';

export async function apiCreateCategory(
    categoryName: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/category/`, {
        method: 'POST',
        body: JSON.stringify({
            categoryName
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetCategory(categoryId: string): Promise<Response> {
    return await fetch(`${config.backendUrl}/category/${categoryId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiDeleteCategory(categoryId: string): Promise<Response> {
    return await fetch(`${config.backendUrl}/category/${categoryId}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiUpdateCategory(
    categoryId: string,
    categoryName: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/category/${categoryId}`, {
        method: 'PUT',
        body: JSON.stringify({ categoryName }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetCategoryAndGroupAggregations(): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/category/groups-and-aggregations`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiGetCategoryKeyFigureAggregations(
    categoryId: string,
    amount?: number
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/category/${categoryId}/keyfigure-aggregations${
            amount ? '?amount=' + amount : ''
        }`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiGetCategoryGroups(
    categoryId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/category/${categoryId}/group`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}
